export default "__VITE_ASSET__BpmJZsbl__"